<div class="edit-title-dialog">
  <h1 class="text-center">Edicion de Titulos</h1>
  <div class="my-3">
    <h5>Título</h5>
    <mat-form-field appearance="outline" class="w-100">
      <input matInput placeholder="Título" [(ngModel)]="data.name">
    </mat-form-field>
  </div>
  <div class="d-flex justify-content-center">
    <button mat-flat-button class="save-button m-3" [mat-dialog-close]="data">Guardar</button>
    <button mat-flat-button color="warn" class="m-3" mat-dialog-close>Cancelar</button>
  </div>
</div>
